/* ALBORA v2 - barra de compra fija, ancla de resenas y bloques plegados en movil. */
(function () {
  var RESENAS = 'main > [id$="__custom_liquid_mtJMBn"], main > [id$="__custom_liquid_iwqpbL"]';
  var UMBRAL = 420;

  function movil() { return window.innerWidth <= 749; }

  function ancla() {
    // La valoracion del hero lleva a #resenas: lo creamos sobre el bloque de opiniones.
    if (document.getElementById('resenas')) return;
    var bloque = document.querySelector(RESENAS);
    if (!bloque) return;
    var punto = document.createElement('span');
    punto.id = 'resenas';
    punto.style.cssText = 'display:block;position:relative;top:-72px;visibility:hidden';
    bloque.insertBefore(punto, bloque.firstChild);
  }

  // Mete los elementos que sobran dentro de un desplegable, sin quitar nada.
  function plegar(caja, desde, rotulo, marca) {
    if (!caja || caja.dataset[marca]) return null;
    var hijos = [].slice.call(caja.children);
    if (hijos.length <= desde) return null;
    caja.dataset[marca] = '1';

    var resto = hijos.slice(desde);
    var plegable = document.createElement('details');
    plegable.className = 'alv2-plegable';
    var titulo = document.createElement('summary');
    titulo.textContent = typeof rotulo === 'function' ? rotulo(resto.length) : rotulo;
    plegable.appendChild(titulo);
    caja.appendChild(plegable);

    resto.forEach(function (f) {
      // Fuera la animacion de aparicion: dentro de un desplegable cerrado no se
      // dispara y el contenido se quedaria invisible al abrirlo.
      f.classList.remove('al-reveal');
      f.removeAttribute('data-al-delay');
      f.style.opacity = '1';
      f.style.transform = 'none';
      plegable.appendChild(f);
    });
    return plegable;
  }

  function comparadores() {
    // Los comparadores de antes/despues apilados ocupan 1.361 px en movil.
    // No se quita ninguno: el primero a la vista y los demas plegados.
    // No valen como carrusel porque se arrastran en horizontal con el dedo y
    // chocaria con el desplazamiento lateral.
    if (!movil()) return;
    plegar(
      document.querySelector('.al-comparadores'),
      1,
      function (n) {
        return n === 1 ? 'Ver la otra comparativa' : 'Ver las otras ' + n + ' comparativas';
      },
      'alv2Comparadores'
    );
  }

  function fichaProducto() {
    // La descripcion del producto son casi 2.000 px seguidos. Se deja la
    // entrada y el resto detras de un desplegable.
    if (!movil()) return;
    var ficha = document.querySelector('.al-descripcion');
    if (!ficha || ficha.children.length < 5) return;
    plegar(ficha, 2, 'Ver la ficha completa', 'alv2Ficha');
  }

  function barraCompra() {
    var barra = document.getElementById('alv2Barra');
    if (!barra) return;
    document.body.classList.add('alv2-con-barra');

    var visible = null;
    function muestra(debe) {
      if (debe === visible) return;
      visible = debe;
      barra.classList.toggle('is-visible', debe);
    }

    // Vigilante fuera de flujo a la altura del umbral: cuando queda por encima
    // de la pantalla, es que ya se paso la primera vista y sacamos la barra.
    var centinela = document.createElement('div');
    centinela.setAttribute('aria-hidden', 'true');
    centinela.style.cssText = 'position:absolute;top:' + UMBRAL + 'px;left:0;width:1px;height:1px;pointer-events:none';
    document.body.appendChild(centinela);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        var e = entradas[0];
        muestra(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(centinela);
    }

    // Red de seguridad por si el navegador no trae IntersectionObserver.
    function porScroll() { muestra(window.scrollY > UMBRAL); }
    porScroll();
    window.addEventListener('scroll', porScroll, { passive: true });
    window.addEventListener('resize', porScroll, { passive: true });

    var oculto = document.getElementById('alv2Variante');
    if (!oculto) return;

    var precio = document.getElementById('alv2Precio');
    var antes = document.getElementById('alv2Antes');
    var tabla = {};
    var datos = document.getElementById('alv2Precios');
    if (datos) {
      try { tabla = JSON.parse(datos.textContent); } catch (e) { tabla = {}; }
    }

    // Selector de variante del bloque de compra de la pagina, no el nuestro.
    function campoPrincipal() {
      var formularios = document.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < formularios.length; i++) {
        if (formularios[i].id === 'alv2Form') continue;
        var campo = formularios[i].querySelector('[name="id"]');
        if (campo && campo.value) return campo;
      }
      return null;
    }

    function sincroniza() {
      var campo = campoPrincipal();
      var id = campo ? String(campo.value) : oculto.value;
      if (!id) return;
      oculto.value = id;

      var fila = tabla[id];
      if (!fila) return;
      if (precio) precio.textContent = fila.p;
      if (antes) {
        if (fila.a) { antes.textContent = fila.a; antes.hidden = false; }
        else { antes.hidden = true; }
      }
    }

    sincroniza();
    document.addEventListener('change', sincroniza);
    document.addEventListener('click', function () { setTimeout(sincroniza, 80); });
  }

  function arranca() {
    ancla();
    comparadores();
    fichaProducto();
    barraCompra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();